module.exports = __webpack_public_path__ + "static/media/mulher.d9392b6f.png";